module.exports = __webpack_public_path__ + "media/images/logo/ketenzorg-b5098ebb6b1e3e53d238ab30a2e22428.png";